<div v-if="shouldRenderConfig" v-bind:class="[getClassName, getDisabledClass]">
    <!-- old tab <button type="button" class="btn btn-primary" v-bind:class="activeClass()" 
      v-on:click="onClickSelectPageOption(code)" 
    >
        <div v-bind:class="getClassName + 'Index'">{{index + 1}}</div>
        <div v-bind:class="getClassName + 'Label'">{{name}}</div>
        <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>
        <appAwesomeIcon v-if="getIsShowCheckedPageOptionFlag && checked" icon="check" useClass="pageOptionCheck" />
    </button> -->
    <div class="btn btn-primary" v-bind:class="activeClass()" v-on:click="onClickSelectPageOption(code)">
        <div v-bind:class="getClassName + 'Index'">{{index + 1}}</div>
        <div v-bind:class="getClassName + 'Label'">{{name}}</div>
        <div v-if="completed" v-bind:class="getClassName + 'Icon'"> <i class="fa fa-check float-right"></i></div>
        <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>
        <appAwesomeIcon v-if="getIsShowCheckedPageOptionFlag && checked" icon="check" useClass="pageOptionCheck" />
    </div>

    <div v-if="getPageAttributesInPageOptions">
        <appPageOptionAttributesContainer v-bind:code="code"></appPageOptionAttributesContainer>
    </div>
</div>